import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  colors: {
    primary: '#1299ff', //light blue
    secondary: '#ffffff',
    button: '#1264A3',
    title: '',
    icons: '#333',
    selectedIcon: '#0261bb',
  },
  barColors: {
    barA: '#318ce4',
    barAOpacity: '#318ce475',
    barB: '#ce35a0',
    barBOpacity: '#ce35a08c',
    barC: '#8568e1',
    barCOpacity: '#8568e196',
    barD: '#4ac4dc',
    barDOpacity: '#4ac4dc66',
  },

  pieColors: {
    colorA: '#ff6384',
    colorB: '#36a2eb',
    colorC: '#ff0d56',
    colorD: '#ffcd56',
    colorE: '#ff6384',
    colorF: '#36a2eb',
    colorG: '#ff0d56',
    colorH: '#ffcd56',
    colorI: '#ff6384',
    colorJ: '#36a2eb',
  },

  kpiColors: {
    contribution: '#fde8f5',
    contributionIcon: '#FDA6D7',
    distribution: '#ecfae6',
    distributionIcon: '#CBEFBE',
    commitment: '#e4f5ef',
    commitmentIcon: '#90D8C5',
    openCommitments: '#fef4d1',
    openCommitmentsIcon: '#FFDC7C',
    transfer: '#6060e6',
    transferIcon: '#4a4aed',
    custom1: '#85fff3',
    custom1Icon: '#85fff3',
    custom2: '#bef7be',
    custom2Icon: '#7af57a',
    custom3: '#fcf0cf',
    custom3Icon: '#fccccf',
    custom4: '#abcdef',
    custom4Icon: '#abcdab',
    custom5: '#fecdff',
    custom5Icon: '#fecdaa',
  },

  kpiNames: {
    contribution: 'Investments',
    distribution: 'Distributions',
    commitment: 'Commitments',
    openCommitments: 'Open Commitments',
    transfer: 'Transfers',
    investedCapital: 'Invested Capital',
    accumulatedInterest: 'Accumulated Interest',
    equityPercentage: 'Equity Percentage',
    category: 'Category',
  },

  categoryColors: {},

  fonts: {
    boldFont: 'system-ui',
    mainFont: 'Lexend',
  },
};

const theme = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setColors(state, { payload }: PayloadAction<any>) {
      state['colors'] = payload;
    },
    setFonts(state, { payload }: PayloadAction<any>) {
      state['fonts'] = payload;
    },
    setBarColors(state, { payload }: PayloadAction<any>) {
      state['barColors'] = payload;
    },
    setKpiColors(state, { payload }: PayloadAction<any>) {
      state['kpiColors'] = payload;
    },
    setPieColors(state, { payload }: PayloadAction<any>) {
      state['pieColors'] = payload;
    },
    setCategoryColors(state, { payload }: PayloadAction<any>) {
      const colors = payload?.colors;
      const categoryColors: Record<string, string> =
        colors?.reduce(
          (acc, { key, value }) => {
            acc[key] = value; // Set the key-value pair in the object
            return acc; // Return the updated accumulator
          },
          {} as Record<string, string>, // Initialize as an empty object
        ) ?? {};
      state['categoryColors'] = categoryColors;
    },
    setKpiNames(state, { payload }: PayloadAction<any>) {
      state['kpiNames'] = payload;
    },
  },
});

export const {
  setColors,
  setFonts,
  setBarColors,
  setKpiColors,
  setCategoryColors,
  setPieColors,
  setKpiNames,
} = theme.actions;

export default theme.reducer;
